import { isTournamentPage, trimTournament, trimTournamentByTourn } from "../../../Common/Common"
import { getDisplayMatches } from '../../useGetMatchList/common';
import { updateTournV2, updateMatchTournV2 } from './updateTournV2'
export const parseUpdTournV2 = (message, topicInfo, contentRef, option) =>{
    let isTournPage = isTournamentPage(contentRef.current.page)
    let rawTourn = contentRef.current.rawTournList.find(x => x.id===message.id)
    if(rawTourn){
        updateTournV2(rawTourn, message, topicInfo)
    }
    if(isTournPage){
        let tourn = contentRef.current.tournData?.tournaments.find(x => x.id == message.id);
        if(tourn){
            updateTournV2(tourn, message, topicInfo)
        }
         if(["ALL", "TOURN"].includes(contentRef.current.selection.type)) {
            contentRef.current.selection.tabs = trimTournamentByTourn(contentRef.current.tournData.tournaments);
        }
    }else{
        if(topicInfo.V2SubType === 'dtl') return
        let matches = contentRef.current.matchData?.matches?.filter(x => x.tournament.id===topicInfo.tournamentid) || []
        matches.forEach(match => {
            updateTournV2(match.tournament, message, topicInfo);
        });
        matches = contentRef.current.rawMatchList.filter(x => x.tournament.id===topicInfo.tournamentid) 
        matches.forEach(match => {
            updateTournV2(match.tournament, message, topicInfo);
        });
        let matchList = getDisplayMatches(contentRef.current.rawMatchList, contentRef.current.page, contentRef.current.offset);
        contentRef.current.listData = { matches : matchList };

        if(["ALL", "TOURN"].includes(contentRef.current.selection.type)) {
            contentRef.current.selection.tabs = trimTournament(contentRef.current.listData.matches);
        }
    }
    
}